/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingH1_listing$ref: FragmentReference;
declare export opaque type AggregatesListingH1_listing$fragmentType: AggregatesListingH1_listing$ref;
export type AggregatesListingH1_listing = {|
  +offerType: OfferType,
  +postcode: ?string,
  +subLocality: ?string,
  +route: ?string,
  +streetNumber: ?string,
  +propertyMainType: ?string,
  +propertyType: ?string,
  +$refType: AggregatesListingH1_listing$ref,
|};
export type AggregatesListingH1_listing$data = AggregatesListingH1_listing;
export type AggregatesListingH1_listing$key = {
  +$data?: AggregatesListingH1_listing$data,
  +$fragmentRefs: AggregatesListingH1_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingH1_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postcode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subLocality",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "route",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "streetNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyMainType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyType",
      "storageKey": null
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'bb655581873b6ce3c61a25cbabb9b894';

export default node;
